import { createContext, type PropsWithChildren, useContext, useMemo } from 'react';

import { type StateCode } from '@cx-modules/types';

export type GeolocationContextData = {
  state: StateCode | '';
};

export const GeolocationContext = createContext<GeolocationContextData | undefined>(undefined);
GeolocationContext.displayName = 'GeolocationContext';

export const GeolocationProvider = ({ children, state }: PropsWithChildren<GeolocationContextData>) => {
  const value = useMemo(() => ({ state }), [state]);

  return <GeolocationContext.Provider value={value}>{children}</GeolocationContext.Provider>;
};

export const useGeolocation = () => {
  const context = useContext(GeolocationContext);
  if (!context) {
    throw new Error('useGeolocation can only be used inside of GeolocationProvider');
  }

  return context;
};
